import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { ChevronDown } from 'lucide-react';

const CONFIGURATOR_LINKS = [
  { path: '/kozijnen', nameKey: 'configurator.kozijnen' },
  { path: '/terrasdeur', nameKey: 'configurator.terrasdeur' },
  { path: '/achterdeur', nameKey: 'configurator.achterdeur' },
  { path: '/voordeur', nameKey: 'configurator.voordeur' },
  { path: '/schuifpui', nameKey: 'configurator.schuifpui' },
  { path: '/keralit', nameKey: 'configurator.keralit' },
];

/**
 * Reset button with dropdown to navigate to other configurators.
 * Use on every configurator page (Kozijnen, Terrasdeur, Achterdeur, Voordeur, Schuifpui, Keralit).
 * @param {() => void} onReset - Called when "Reset" is clicked; should reset config to default.
 */
const ResetConfigDropdown = ({ onReset }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="inline-flex rounded-lg border border-slate-600 overflow-hidden bg-slate-700/50">
      <button
        type="button"
        onClick={onReset}
        className="px-3 py-2 text-sm font-medium text-white hover:bg-slate-600 transition-colors"
      >
        {t('configurator.reset') || 'Reset'}
      </button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className="px-2 py-2 text-white hover:bg-slate-600 transition-colors border-l border-slate-600"
            aria-label={t('configurator.otherConfigurators') || 'Other configurators'}
          >
            <ChevronDown className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[10rem] bg-white text-gray-900">
          <DropdownMenuItem
            onClick={() => navigate('/')}
            className="cursor-pointer font-medium"
          >
            {t('configurator.home') || 'Home'}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          {CONFIGURATOR_LINKS.map(({ path, nameKey }) => (
            <DropdownMenuItem
              key={path}
              onClick={() => navigate(path)}
              className="cursor-pointer"
            >
              {t(nameKey)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ResetConfigDropdown;
